var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLtoeSavedJobs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64.9 57.2",
    style: {
      enableBackground: "new 0 0 64.9 57.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E5F1FA;}\n\t.st1{fill:#BFDDF1;}\n\t.st2{fill:#FFC56E;}\n\t.st3{fill:#2A3953;}\n\t.st4{fill:#EF6552;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.9,55.4H9c-1.9,0-3.4-1.5-3.4-3.4V5.2c0-1.9,1.5-3.4,3.4-3.4h36.8l13.5,13.8V52 C59.3,53.9,57.8,55.4,55.9,55.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.3,18.2H21.6c-1.4,0-2.5-1.1-2.5-2.5v-14h26.7v14C45.8,17.1,44.7,18.2,43.3,18.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.6,55.4h5.3c1.9,0,3.4-1.5,3.4-3.4V15.6l-8.7-8.9V55.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.1,1.8v14c0,1.4-1.1,2.5-2.5,2.5h6.7c1.4,0,2.5-1.1,2.5-2.5v-14C45.8,1.8,39.1,1.8,39.1,1.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36.7,
    y: 5.8,
    className: "st2",
    width: 4.2,
    height: 8.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.9,56.6H9c-2.5,0-4.6-2-4.6-4.6V5.2c0-2.5,2-4.6,4.6-4.6h36.8c0.3,0,0.6,0.1,0.8,0.4l13.5,13.8 c0.2,0.2,0.3,0.5,0.3,0.8V52C60.5,54.6,58.4,56.6,55.9,56.6z M9,2.9c-1.2,0-2.2,1-2.2,2.2V52c0,1.2,1,2.2,2.2,2.2h46.9 c1.2,0,2.2-1,2.2-2.2V16L45.3,2.9H9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M43.3,19.4H21.6c-2,0-3.6-1.6-3.6-3.6v-14c0-0.6,0.5-1.2,1.2-1.2h26.7c0.6,0,1.2,0.5,1.2,1.2v14 C47,17.8,45.3,19.4,43.3,19.4z M20.3,2.9v12.8c0,0.7,0.6,1.3,1.3,1.3h21.8c0.7,0,1.3-0.6,1.3-1.3V2.9H20.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M40.9,15.2h-4.2c-0.6,0-1.2-0.5-1.2-1.2V5.8c0-0.6,0.5-1.2,1.2-1.2h4.2c0.6,0,1.2,0.5,1.2,1.2V14 C42.1,14.6,41.5,15.2,40.9,15.2z M37.9,12.8h1.9V6.9h-1.9V12.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2180",
    transform: "translate(2474.915 3841.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2178",
    transform: "translate(1.222 1.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    className: "st4",
    d: "M-2434.5-3810.7h-6v-6h-6.2v6h-6v6.2h6v6h6.2v-6h6V-3810.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    className: "st3",
    d: "M-2439.3-3796.1h-6.2c-0.7,0-1.2-0.5-1.2-1.2v-4.9h-4.9c-0.7,0-1.2-0.5-1.2-1.2v-6.2 c0-0.7,0.5-1.2,1.2-1.2h4.8v-4.9c0.1-0.7,0.6-1.2,1.3-1.2h6.2c0.7,0,1.2,0.5,1.2,1.2v4.8h4.9c0.7,0,1.2,0.5,1.2,1.2v6.2 c0,0.7-0.5,1.2-1.2,1.2h-4.9v5C-2438.2-3796.6-2438.7-3796.1-2439.3-3796.1z M-2444.4-3798.4h3.9v-4.8c0-0.7,0.5-1.2,1.2-1.2h4.8 v-3.9h-4.8c-0.7,0-1.2-0.5-1.2-1.2v-5h-3.9v4.8c0,0.7-0.5,1.2-1.2,1.2h-4.9v3.9h4.8c0.7,0,1.2,0.5,1.2,1.2L-2444.4-3798.4z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtoeSavedJobs);
export default __webpack_public_path__ + "static/media/ltoe-saved-jobs.73538941829cc8aec318e988b7bc37c4.svg";
export { ForwardRef as ReactComponent };